import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { SocialProofBar } from './components/SocialProofBar';
import { TestimonialFeatured } from './components/TestimonialFeatured';
import { PainSection } from './components/PainSection';
import { ProductReveal } from './components/ProductReveal';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingCards } from './components/PricingCards';
import { MaquinaAdministrativa } from './components/MaquinaAdministrativa';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CostSection } from './components/CostSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SocialProofToast } from './components/SocialProofToast';
export function App() {
  useEffect(() => {
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      (window as any).fbq('init', '1349873706968654');
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-[#f8fafc] text-[#0f172a] selection:bg-[#22c55e]/30 font-sans overflow-x-hidden space-y-[0px]" data-id="element-0">
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1349873706968654&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <HeroSection data-id="element-3" />
      <SocialProofBar data-id="element-4" />
      <TestimonialFeatured data-id="element-5" />
      <PainSection data-id="element-6" />

      <div className="bg-gradient-to-b from-[#f8fafc] via-[#e2e8f0]/30 to-[#f8fafc]" data-id="element-7">
        <ProductReveal data-id="element-8" />
        <TomosSection data-id="element-9" />

        <div className="max-w-3xl mx-auto px-4 py-3 md:py-6" data-id="element-10">
          <div className="bg-[#22c55e]/10 border border-[#22c55e]/20 rounded-2xl p-4 md:p-6 shadow-sm" data-id="element-11">
            <h3 className="text-base md:text-xl font-bold text-[#16a34a] mb-2.5 md:mb-4 flex items-center gap-2" data-id="element-12">
              <span className="text-xl md:text-2xl" data-id="element-13">✅</span> Todo incluye:
            </h3>
            <ul className="space-y-2 md:space-y-3 text-sm md:text-base" data-id="element-14">
              {['Protocolos paso a paso con diagramas y ejemplos reales', 'Tablas de referencia y checklists listos para usar', 'Adaptado a la realidad y el presupuesto argentino', 'Funciona para corredores de asfalto, trail y mixto', 'Sin equipamiento caro ni conocimiento previo necesario'].map((item, i) => <li key={i} className="flex items-start gap-3 text-[#475569] font-medium" data-id="element-15">
                  <span className="text-[#22c55e] mt-1 font-bold" data-id="element-16">✓</span>{' '}
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>

      <BonusSection data-id="element-17" />
      <CountdownTimer data-id="element-18" />
      <PricingCards data-id="element-19" />
      <MaquinaAdministrativa data-id="element-20" />
      <TestimonialsSection data-id="element-21" />
      <GuaranteeSection data-id="element-22" />
      <FAQSection data-id="element-23" />
      <CostSection data-id="element-24" />
      <FinalCTA data-id="element-25" />
      <Footer data-id="element-26" />
      <SocialProofToast data-id="element-27" />
    </div>;
}